@import '../../utils/chrome-header.css';
@import '../../utils/chrome-layout.css';
@import '../../utils/forced-colors.css';

:host {
  display: contents;
}

.modal-dialog {
  display: none;
  flex-direction: column;
  max-width: none;
  max-height: calc(100vh - 2 * var(--dimension-space-200));
  margin: auto;
  padding: 0;
  overflow: hidden;
  color: var(--color-foreground-primary);
  background-color: var(--color-background-primary);
  border: 0;
  border-radius: var(--dimension-radius-050);
  box-shadow: var(--effect-elevation-elevated-floating);
  outline: none;
  box-sizing: border-box;
  animation: modalDialogIn var(--effect-motion-short-2) forwards;
}

.modal-dialog[open] {
  display: flex;
}

.modal-dialog::backdrop {
  background-color: var(--color-background-shade);
  animation: modalBackdropIn var(--effect-motion-short-2) forwards;
}

.modal-dialog--closing {
  animation: modalDialogOut var(--effect-motion-short-2) forwards;
}

.modal-dialog--closing::backdrop {
  animation: modalBackdropOut var(--effect-motion-short-2) forwards;
}

@keyframes modalBackdropIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes modalBackdropOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}

@keyframes modalDialogIn {
  from { opacity: 0; transform: scale(0.97) translateY(4px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

@keyframes modalDialogOut {
  from { opacity: 1; transform: scale(1) translateY(0); }
  to   { opacity: 0; transform: scale(0.97) translateY(4px); }
}

@media (prefers-reduced-motion: reduce) {
  .modal-dialog[open],
  .modal-dialog--closing {
    animation: none;
    transform: none;
  }

  .modal-dialog::backdrop {
    animation: none;
    opacity: 1;
  }

  .modal-dialog--closing,
  .modal-dialog--closing::backdrop {
    opacity: 0;
  }
}

.modal-header {
  align-items: flex-start;
  flex: 0 0 auto;
  color: var(--color-foreground-primary);
}

.modal-copy,
ds-text.modal-heading,
ds-text.modal-description {
  width: auto;
  text-align: left;
}

ds-text.modal-heading {
  -webkit-user-select: none;
  user-select: none;
}

.modal-close-tooltip {
  flex: 0 0 auto;
}

.modal-content {
  min-height: 0;
  padding: var(--dimension-space-200);
  overflow-y: auto;
  flex: 1 1 auto;
  box-sizing: border-box;
}

.modal-footer {
  justify-content: flex-start;
  height: var(--dimension-size-800);
  flex: 0 0 auto;
  border-top: var(--dimension-stroke-width-012) solid var(--color-border-tertiary);
}

.modal-footer__actions {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-100);
  min-width: 0;
}

.modal-footer--empty {
  display: none;
}

.modal-footer__actions slot {
  display: contents;
}

@media (forced-colors: active) {
  .modal-dialog {
    box-shadow: none;
    outline: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
    outline-offset: calc(-1 * var(--dimension-stroke-width-012));
  }
}
